/**
 * Maps individual onboarding backend entity names to review step routes.
 */
import { resolveStepRoute } from './entity-step-mapping';

export const INDIVIDUAL_ENTITY_TO_STEP_ROUTE: Readonly<Record<string, string>> = {
  ClientInformation: 'client-information',
  IndividualPersonalInformation: 'client-information',
  PersonalInformation: 'client-information',

  IndividualAddress: 'contact-address',
  IndividualAddressCorrespondence: 'contact-address',
  AddressCorrespondence: 'contact-address',
  ContactAndAddress: 'contact-address',

  EmploymentIncome: 'employment-and-income',
  EmploymentAndIncome: 'employment-and-income',
  IndividualEmploymentAndWealth: 'employment-and-income',
  EmploymentFinancialExperience: 'employment-and-income',

  IndividualPepDeclaration: 'declarations',
  IndividualPepDeclarations: 'declarations',
  IndividualClientDeclarations: 'declarations',
  PepDeclarations: 'declarations',
  ClientDeclarations: 'declarations',
  IncomeWealthCompliance: 'declarations',
  // Completeness API entity name (validator/entity-completeness-statuses)
  Declaration: 'declarations',

  IndividualBankSettlement: 'bank-information',
  BankInformation: 'bank-information',
  IndividualBankInformation: 'bank-information',
  BankSettlement: 'bank-information',
  // Completeness API entity name (validator/entity-completeness-statuses)
  BankAndSettlement: 'bank-information',
  BankAndCustodian: 'bank-information',
  BankPaymentRouting: 'bank-information',

  IndividualInvestmentProfile: 'investment-profile',
  IndividualInvestmentBackground: 'investment-profile',
  InvestmentBackground: 'investment-profile',
  InvestmentProfile: 'investment-profile',

  IndividualRiskSuitability: 'risk-suitability',
  RiskSuitability: 'risk-suitability',
  SuitabilityAssessment: 'risk-suitability',

  IndividualFatcaCrs: 'fatca-crs',
  FatcaCrsProfile: 'fatca-crs',
  FatcaCrs: 'fatca-crs',
  IndividualCrsTaxResidency: 'fatca-crs',
  CrsTaxResidency: 'fatca-crs',
  FatcaCrsControllingPerson: 'fatca-crs',

  ApplicationDocument: 'documents',
  EntityDocument: 'documents',
  PersonDocument: 'documents',
  Documents: 'documents',
  SignedDocument: 'signed-documents',
  SignedDocuments: 'signed-documents',

  // Assessment step — completeness API entity names (IndividualAssessment, IsSignedAssessmentVerified)
  IndividualAssessment: 'assessment',
  Assessment: 'assessment',
  IsSignedAssessmentVerified: 'assessment',
};

export function resolveIndividualStepRoute(entityName: string): string | null {
  if (!entityName?.trim()) {
    return null;
  }
  return INDIVIDUAL_ENTITY_TO_STEP_ROUTE[entityName] ?? null;
}

/** Resolves corporate or individual onboarding entity names to a stepper route. */
export function resolveOnboardingStepRoute(entityName: string): string | null {
  return resolveIndividualStepRoute(entityName) ?? resolveStepRoute(entityName);
}
